import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { School } from '@teetsh/app/src/types/school';
import { Schoolyear } from '@teetsh/app/src/types/schoolyear';
import { UserLocale } from '@teetsh/app/src/types/user';
import { ProgrammationOptions } from 'components/ShareEntity';

function fetch({ userId, token }: { userId: string; token: string }) {
  const requestURL = `/shares/${userId}/programmation/${token}`;
  return request(requestURL, {
    method: 'GET',
  }).then<ShareProgrammationData>(data => ({ ...data }));
}

export interface ShareProgrammationData {
  classrooms: Classroom[];
  school: School;
  schoolyear: Schoolyear;
  permission: 'read' | 'write';
  tz: string;
  locale: UserLocale;
  country: string;
  programmationId: string;
  options: ProgrammationOptions;
}

export function useGetShareProgrammation(userId: string, token: string) {
  return useQuery({
    queryKey: ['programmationShare'],
    queryFn: () =>
      fetch({
        userId,
        token,
      }),

    // 10 mins
    staleTime: 10 * (60 * 1000),

    // 15 mins
    gcTime: 15 * (60 * 1000),

    refetchOnWindowFocus: false,

    retry: (failCount, err) => {
      if (err?.response?.status === 404) {
        return false;
      }
      return failCount < 1;
    },
  });
}
